import React, { useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import axios from "../../../axios";

const DuplicateErr = ({props,ID}) => {
  const handleDelete=async()=>{
    let res = await axios.delete(`/api/v1/timetable/delete/${ID}`);
    console.log(res);
    if(res.status===200){
      window.location.reload();
    }
  }
  return (
    <>
      <div className="full_details1">
        <img
          src="/images/cross-circle3.svg"
          className="create_channel_close_btn"
          alt="cross circle"
          onClick={props.helper1}
        />
        <div className="divText">A timetable already exists in the system ,what would you like to </div>
        <div className="divText1">do with it?</div>
        <div className="btnSty">
        <button id="pub_btn1">Update Existing</button>
        <button id="pub_btn2" onClick={()=>{handleDelete()}}>Create New</button>
        </div>
      </div>
    </>
  );
};

export default DuplicateErr;
